import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getUiInterface } from "../../../locales/translationUtils";

interface CancelConfirmationModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    shipId: number | null;
}

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({ show, onClose, onConfirm, shipId }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{getUiInterface('confirmCancel')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {getUiInterface('cancelShippingID', { id: shipId ?? '' })}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>{getUiInterface('cancel')}</Button>
                <Button variant="danger" onClick={onConfirm}>{getUiInterface('yes')}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelConfirmationModal;
